module.exports = __webpack_public_path__ + "img/kiwi_exzoticfarms.62c050f.png";